// Images: drop files into public/vibe/ and add entries like:
// { type: 'image', content: '/vibe/filename.jpg' }
// Links: { type: 'link', content: 'https://...' }

export const vibeItems = [
  { type: 'image', content: '/vibe/avs-game.jpg' },
  { type: 'image', content: '/vibe/ai.jpg' },
  { type: 'image', content: '/vibe/tumblr_1866b3d7eb56144959d062ef6bdf23a7_8ee765c4_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_3d902255c4f2613b87ce0f722b746b29_4ba9cb1b_640.jpg' },
  { type: 'image', content: '/vibe/tiger-vintage.jpg' },
  { type: 'image', content: '/vibe/sukiyaki-1.jpg' },
  { type: 'image', content: '/vibe/tumblr_191b0565a3f8253c51cecf7ee7818bb7_521db919_640.jpg' },
  { type: 'image', content: '/vibe/ai-court.jpg' },
  { type: 'image', content: '/vibe/bonsai.jpg' },
  { type: 'link',  content: 'https://shopcanoeclub.com/' },
  { type: 'image', content: '/vibe/tumblr_3f82d1df2edb7115bfce48d646231d5f_d96d29ef_640.jpg' },
  { type: 'image', content: '/vibe/tiger-mj.jpg' },
  { type: 'image', content: '/vibe/tumblr_1a6a270a012892ce690bbc7f447cdaf4_12fc23d7_640.jpg' },
  { type: 'link',  content: 'https://www.behance.net/' },
  { type: 'image', content: '/vibe/tumblr_62d1424632a15043719f3f0a0e2d9cfc_7daa314f_640.jpg' },
  { type: 'image', content: '/vibe/ai-crowd.jpg' },
  { type: 'image', content: '/vibe/tumblr_21d6e147b403c245909fb12de7a3e12a_f63f299b_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_7ceb916f0758eeba207367637cbfb62d_822299a1_640.jpg' },
  { type: 'link',  content: 'https://kolor.jp/' },
  { type: 'image', content: '/vibe/tumblr_254036e02890b8d74e8c25ea1777ed3d_7b4cac33_640.jpg' },
  { type: 'image', content: '/vibe/jerome-cal.jpg' },
  { type: 'image', content: '/vibe/tumblr_2d82595f8d2b95f56450d8c7388b20b0_e9587657_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_835bc5c5df08525f41b91b3c9079c768_78c8081a_640.jpg' },
  { type: 'image', content: '/vibe/ai-dribble.jpg' },
  { type: 'image', content: '/vibe/tumblr_18d09ee96b66e8153ec855518d8c180a_4eaccb32_1280.jpg' },
  { type: 'image', content: '/vibe/tumblr_53b4b17a863bcdd55211adfa1476ba4b_1a365c96_640.jpg' },
  { type: 'image', content: '/vibe/dump-3.jpg' },
  { type: 'link',  content: 'https://www.doverstreetmarket.com/' },
  { type: 'image', content: '/vibe/tiger-stanford.jpg' },
  { type: 'image', content: '/vibe/tumblr_f6bbcae8628ad4c541f15067100fafd3_f1cca720_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_6e04e623d108c90e977d880659182ba1_e5f96a5d_640.jpg' },
  { type: 'image', content: '/vibe/youngthug_3.jpg' },
  { type: 'image', content: '/vibe/ai-fit.jpg' },
  { type: 'image', content: '/vibe/tumblr_f585ab8adf95c316f78677d07e3f376e_91836b06_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_820951f43b1f51782d219401a218ad62_c8279367_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_3ed53c4c881b5114cdb4db6b9a64d67a_00b7a396_2048.jpg' },
  { type: 'link',  content: 'https://fujixweekly.com/' },
  { type: 'link',  content: 'https://www.blackbirdspyplane.com/' },
  { type: 'image', content: '/vibe/desean-cal.jpeg' },
  { type: 'image', content: '/vibe/avs-bench.jpg' },
  { type: 'image', content: '/vibe/tumblr_9ccfe8367e669e66074a0908232941f1_4a11cc3c_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_a42c1802a1ad54dadfc0a4cb6348c144_fc6d600c_640.jpg' },
  { type: 'image', content: '/vibe/tiger-swing.jpg' },
  { type: 'image', content: '/vibe/tumblr_f579a781fecfdc8652ef56b984fb5262_7e312a5b_640.jpg' },
  { type: 'image', content: '/vibe/Screenshot 2026-05-07 at 14.59.32.png' },
  { type: 'link',  content: 'https://n-hoolywood.com/' },
  { type: 'image', content: '/vibe/ai-fit-2.jpg' },
  { type: 'image', content: '/vibe/tumblr_a88b7d6ecf76f9bb07c46abc734b0b95_9b6a77b7_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_cef692ffab4a68f7cefe9758487f7db7_65e7d700_640.jpg' },
  { type: 'image', content: '/vibe/marshawn-cal-cart.jpeg' },
  { type: 'image', content: '/vibe/tumblr_27b7b2c80707f503d5b48216fafb98e5_b622e873_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_9516fe324a83b7f6a5d4a4e5bd466ae9_81fad399_1280.jpg' },
  { type: 'link',  content: 'https://radio.garden/browse' },
  { type: 'image', content: '/vibe/golf-cig.jpg' },
  { type: 'image', content: '/vibe/tumblr_b3ea28d2f799e0ec88743c7335eb3ab0_79d0fa31_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_37146950017691bb471bb0055caa6873_55809e68_640.jpg' },
  { type: 'image', content: '/vibe/dump-1.jpg' },
  { type: 'image', content: '/vibe/ai-lay.jpg' },
  { type: 'image', content: '/vibe/tumblr_cd3a6068d1fda70af66243f28f8b105f_523966a5_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_b720a97f76a965918ff6a27ebc1c151d_d21bcf30_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_3c9b225ce46b5ab2bfb1becaf476e56c_a4fd654b_640.jpg' },
  { type: 'image', content: '/vibe/tiger-crowd.jpg' },
  { type: 'image', content: '/vibe/tumblr_fe9f837adefd6babce3bc2a0badebc00_9a8995f3_640.jpg' },
  { type: 'link',  content: 'https://wplace.live/' },
  { type: 'link',  content: 'https://www.pi.fyi/' },
  { type: 'image', content: '/vibe/tumblr_b8dd56769dd74de787104493d7652c17_3fb75fc5_640.jpg' },
  { type: 'image', content: '/vibe/desean-cal-2.jpeg' },
  { type: 'image', content: '/vibe/avs-game-2.jpg' },
  { type: 'image', content: '/vibe/tumblr_a4756ce2aeb052fc22c0223ba17342ff_399276f2_640.jpg' },
  { type: 'image', content: '/vibe/ai-shoe.jpg' },
  { type: 'image', content: '/vibe/tumblr_45086358fb785c29695450dec0c843bb_6ad0a85c_640.jpg' },
  { type: 'link',  content: 'https://www.houyhnhnm.jp/' },
  { type: 'image', content: '/vibe/nba-cig.jpg' },
  { type: 'image', content: '/vibe/tumblr_cb0ed6069be3f072140bcfc5c1c7c2d4_f776656b_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_c13da83f10196f1f00f871411aef0e20_7c5cff91_640.jpg' },
  { type: 'image', content: '/vibe/Screenshot 2026-05-07 at 15.00.06.png' },
  { type: 'image', content: '/vibe/tiger-ea.jpg' },
  { type: 'image', content: '/vibe/tumblr_895d004bf15d9b65ce4ae61b5ff59096_0901d4d9_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_3d6e0bba6280f86864c93a7090463faf_94677717_500.jpg' },
  { type: 'image', content: '/vibe/tumblr_ffd4c27e5f0d54b01261991e1a79050d_9b659264_640.jpg' },
  { type: 'link',  content: 'https://popeyemagazine.jp/genre/fashion/' },
  { type: 'image', content: '/vibe/marshawn-lynch-golf-cart.jpg' },
  { type: 'image', content: '/vibe/tumblr_e5fa6254de6fc18f3729c24e1806954b_32751a13_640.jpg' },
  { type: 'image', content: '/vibe/dump-2.jpg' },
  { type: 'image', content: '/vibe/tumblr_3370479f1ed03f9f6c0aef64302473d0_981b820d_400.jpg' },
  { type: 'image', content: '/vibe/tumblr_2781b366265eb7caeb75229cbc408de9_b25a702e_640.jpg' },
  { type: 'link',  content: 'https://yakkun-fashion.jp/' },
  { type: 'link',  content: 'https://www.thefriedegg.com/' },
  { type: 'image', content: '/vibe/ai-sit.jpg' },
  { type: 'image', content: '/vibe/tumblr_e910dd8d810ca6aab43d3361dcfe72a5_6aa2fc41_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_e75c0451fff5983888ad8efb5e481588_0d4c5eb8_640.jpg' },
  { type: 'image', content: '/vibe/tiger-meeting.jpg' },
  { type: 'image', content: '/vibe/tumblr_cf86ab8fba02c7c281dd586064d78b68_d431f2ea_640.jpg' },
  { type: 'image', content: '/vibe/trees.jpg' },
  { type: 'image', content: '/vibe/tumblr_f65e0a8671511d7966cd7ebe4d31e620_2618dfaa_1280.jpg' },
  { type: 'image', content: '/vibe/golf-vintage.jpg' },
  { type: 'image', content: '/vibe/tumblr_9ad6f96ee68a17eab378882ca6fa68f4_001dbe37_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_498094ebe825e0bfb9528e765ec6f147_32085946_1280.jpg' },
  { type: 'link',  content: 'https://leica-camera.com/' },
  { type: 'image', content: '/vibe/desean-cal-3.jpg' },
  { type: 'image', content: '/vibe/tumblr_5c1f0a1363dd1571ea632584dea743e1_aef12cad_500.jpg' },
  { type: 'image', content: '/vibe/tumblr_fdf726bf576620d1b6fa58429b1e2613_d1231526_640.jpg' },
  { type: 'image', content: '/vibe/Screenshot 2026-05-07 at 15.00.19.png' },
  { type: 'image', content: '/vibe/tumblr_e06cc019ee180d32c973389d14abdc88_b80e751b_640.jpg' },
  { type: 'image', content: '/vibe/jerome-randle-2a6054b9-74d4-401d-8bd0-af0acde6399-resize-750.jpeg' },
  { type: 'image', content: '/vibe/tumblr_8cecc30eccad12ff1e6574466e297629_55c92bb8_500.jpg' },
  { type: 'image', content: '/vibe/portra-1.jpg' },
  { type: 'link',  content: 'https://dribbble.com/' },
  { type: 'link',  content: 'https://tokyofashion.com/' },
  { type: 'image', content: '/vibe/tiger-vintage-1.jpg' },
  { type: 'image', content: '/vibe/tumblr_ac704239c9b8aea5a48290c4943e564b_e20e15dc_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_88a55489e9f1a8f368ad44c709e81fec_6235274d_640.jpg' },
  { type: 'image', content: '/vibe/marshawn-cal.jpg' },
  { type: 'image', content: '/vibe/tumblr_32d1e21faee0576f021973a7a9d8cb0c_b523bdba_640.jpg' },
  { type: 'link',  content: 'https://pageflows.com/' },
  { type: 'image', content: '/vibe/tumblr_o4cy7xDVHv1qcc8nno1_500.jpg' },
  { type: 'image', content: '/vibe/nike-golf-shoes.jpg' },
  { type: 'image', content: '/vibe/Screenshot 2026-05-07 at 15.00.54.png' },
  { type: 'image', content: '/vibe/tumblr_7a983485df2f2ed928147ba19e5ad581_1caeeee9_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_49f2351fc9330bab90e1e690564d2262_05d5ad41_500.jpg' },
  { type: 'image', content: '/vibe/california-golden-bears-guard-jerome-randle-shoots-free-editorial_image.jpg' },
  { type: 'image', content: '/vibe/tumblr_f2533ec020910607067180ecc64b5f6e_448030c1_640.jpg' },
  { type: 'link',  content: 'https://godly.website/' },
  { type: 'link',  content: 'https://cottle.shop/' },
  { type: 'image', content: '/vibe/shawn-lamp-cal.jpeg' },
  { type: 'image', content: '/vibe/tumblr_b48934706a2d656ba012a801c01d3d31_86ae6e70_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_a653287c5bce2e795001bbf2ceb669f5_e48d5029_640.jpg' },
  { type: 'image', content: '/vibe/dump-5.jpg' },
  { type: 'link',  content: 'https://www.awwwards.com/' },
  { type: 'image', content: '/vibe/images.jpeg' },
  { type: 'image', content: '/vibe/tumblr_64ce0b65071a6ef5d6fc59074be27000_a12aa4c5_500.jpg' },
  { type: 'image', content: '/vibe/Screenshot 2026-05-07 at 15.01.25.png' },
  { type: 'image', content: '/vibe/tiger-walk.jpg' },
  { type: 'image', content: '/vibe/tumblr_3181a7624ede4a5b903aa783db286280_de22a1e2_400.jpg' },
  { type: 'image', content: '/vibe/tumblr_3567de88232a216f61a82646647b5ac5_3bd00190_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_d7f9335c3607fef243ed09fdf613431b_e987ff75_400.jpg' },
  { type: 'link',  content: 'https://www.landingfolio.com/' },
  { type: 'image', content: '/vibe/portra-2.jpg' },
  { type: 'image', content: '/vibe/tumblr_336cac603abf1f13927c8c46b1115fd8_6ef38bb8_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_6630134a26e82b0666a67540b7e5645f_5ac42a37_640.jpg' },
  { type: 'image', content: '/vibe/tumblr_f21271a87ffa4e2288c94f1abac65de9_e018ba60_640.jpg' },
  { type: 'link',  content: 'https://mobbin.com/' },
  { type: 'link',  content: 'https://eng.graphpaper-tokyo.com/' },
  { type: 'image', content: '/vibe/dump-6.jpg' },
  { type: 'image', content: '/vibe/tumblr_385963661cd990c1d82045b19f4bc46f_7cdc23d2_640.jpg' },
  { type: 'image', content: '/vibe/Screenshot 2026-05-07 at 15.01.36.png' },
  { type: 'link',  content: 'https://screensdesign.com/' },
  { type: 'image', content: '/vibe/dump-4.jpg' },
  { type: 'image', content: '/vibe/Screenshot 2026-05-07 at 15.03.22.png' },
];
